module.exports = __webpack_public_path__ + "img/page-064.328981a2.jpg";